/**
 * Copyright (C) SiteVision AB 2002-2026, all rights reserved
 */
const getNewLocation = (trigger) =>
  trigger.tagName === 'A'
    ? trigger.getAttribute('href')
    : trigger.dataset.svFormNewLocation;

const openPopup = (trigger) => {
  const href = trigger.dataset.svFormPopupUrl || trigger.getAttribute('href');

  if (!href) {
    return false;
  }

  const parsedWidth = Number.parseInt(trigger.dataset.svFormPopupWidth, 10);
  const parsedHeight = Number.parseInt(trigger.dataset.svFormPopupHeight, 10);
  const popupName = trigger.dataset.svFormPopupName || 'svFormValues';
  const left = Number.isNaN(parsedWidth) ? 0 : (screen.width - parsedWidth) / 2;
  const top = Number.isNaN(parsedHeight) ? 0 : (screen.height - parsedHeight) / 2;
  const features = [
    'toolbar=0',
    'scrollbars=1',
    'location=0',
    'statusbar=0',
    'menubar=0',
    'resizable=1',
    `width=${parsedWidth}`,
    `height=${parsedHeight}`,
    `left=${left}`,
    `top=${top}`,
  ].join(',');

  window.open(href, popupName, features)?.focus();
  return true;
};

document.addEventListener('click', (e) => {
  if (!(e.target instanceof Element)) {
    return;
  }

  const popupTrigger = e.target.closest(
    '.sv-form-portlet [data-sv-form-popup], .sv-dbform-portlet [data-sv-form-popup], .sv-survey-portlet [data-sv-form-popup], .sv-booking-portlet [data-sv-form-popup]'
  );
  if (popupTrigger) {
    e.preventDefault();
    openPopup(popupTrigger);
    return;
  }

  const trigger = e.target.closest(
    '.sv-signup-portlet [data-sv-form-confirm-msg], .sv-dbform-portlet [data-sv-form-confirm-msg], .sv-survey-portlet [data-sv-form-confirm-msg], .sv-booking-portlet [data-sv-form-confirm-msg]'
  );
  if (trigger) {
    const confirmMsg = trigger.dataset.svFormConfirmMsg;
    if (!confirmMsg) {
      return;
    }

    if (!window.confirm(confirmMsg)) {
      e.preventDefault();
      return;
    }

    const newLocation = getNewLocation(trigger);

    if (newLocation) {
      e.preventDefault();
      window.location.href = newLocation;
    }
    return;
  }

  const input = e.target.closest(
    '.sv-dbform-portlet [data-sv-form-new-location], .sv-survey-portlet [data-sv-form-new-location], .sv-booking-portlet [data-sv-form-new-location]'
  );
  if (input) {
    const newLocation = input.dataset.svFormNewLocation;

    if (newLocation) {
      e.preventDefault();
      window.location.href = newLocation;
    }
    return;
  }

  const historyBackTrigger = e.target.closest('.sv-survey-portlet [data-sv-form-history-back]');
  if (historyBackTrigger) {
    e.preventDefault();
    window.history.back();
    return;
  }

  const closeTrigger = e.target.closest('[data-sv-form-close-action]');
  if (!closeTrigger) {
    return;
  }

  e.preventDefault();

  const closeAction = closeTrigger.dataset.svFormCloseAction;
  if (closeAction === 'reload-opener-top') {
    window.opener?.top?.location?.reload();
    window.close();
    return;
  }

  if (closeAction === 'reload-opener') {
    window.opener?.location?.reload();
    window.close();
    return;
  }

  if (closeAction === 'close') {
    window.close();
  }
});

document.addEventListener('change', (e) => {
  if (!(e.target instanceof HTMLSelectElement)) {
    return;
  }

  const select = e.target.closest('.sv-survey-portlet [data-sv-form-new-location-on-change]');
  if (!select) {
    return;
  }

  const newLocation = select.value;
  if (newLocation) {
    window.location.href = newLocation;
  }
});
